import { ContentSlugsObject } from "@robe/core-types";
import { parseQueryParamsObject } from "@robe/core-utils";
import { XcoreCore } from "XcoreCore";
import { BaseApiRequest } from "../baseApiRequest";

export const getContentSlugsByTypes = (core: XcoreCore, contentTypes?: string[]): BaseApiRequest<ContentSlugsObject> =>
  core.fetch(`/api/content/slugs${parseQueryParamsObject({ contentTypes })}`).then((res) => res.json());
